<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <!-- แจ้งเตือนย้ายครู -->
        <v-hover v-slot="{ hover }">
          <v-card
            :elevation="hover ? 16 : 2"
            :class="{ 'on-hover': hover }"
            class="pa-2"
            v-if="(periods.period_enable === '1' || periods.period_enable === 1)"
          >
            <v-row>
              <v-col cols="6">
                <v-alert
                  outlined
                  prominent
                  icon="mdi-bell-ring"
                  type="error"
                  border="left"
                >
                  <v-row align="center">
                    <v-col class="grow">
                      <h2 class="primary--text">
                        <v-icon color="primary">mdi-account</v-icon>
                        ข้าราชการครู
                      </h2>
                      <h2>สามารถดำเนินการ <u>ยื่นคำร้องขอย้าย</u></h2>
                      <h3>
                        ก่อนระบบปิดในวันที่
                        {{
                          periods.period_stop
                            | moment("add", "543 years")
                            | moment("D MMMM YYYY")
                        }}
                      </h3>
                    </v-col>
                  </v-row>
                </v-alert>
              </v-col>
              <v-col cols="6">
                <div class="text-center">
                  <h3>
                    ปิดระบบ <u>ยื่นคำร้องขอย้าย</u> :
                    {{
                      periods.period_stop
                        | moment("add", "543 years")
                        | moment("D MMMM YYYY")
                    }}
                    <br />
                    เหลือเวลาอีก
                  </h3>
                  <flip-countdown
                    :deadline="periods.period_stop + ' 16:30:00'"
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>

      <v-col cols="12">
        <base-material-card color="primary">
          <template v-slot:heading>
            <h2 class="h1 font-weight-light">
              <v-icon large left>mdi-file-send</v-icon>การย้าย พนักงานราชการ
            </h2>
          </template>

          <div>
            <v-row align="stretch">
              <v-col cols="12" md="6">
                <v-alert
                  border="left"
                  colored-border
                  color="success darken-1"
                  elevation="2"
                  type="info"
                  class="flex-card"
                >
                  <h2>
                    ชื่อ-นามสกุล : {{ user.title_s }}{{ user.frist_name }}
                    {{ user.last_name }}
                  </h2>
                  <h3>รหัสบัตรประชาชน : {{ user.id_card }}</h3>
                  <h3>อายุ : {{ get_ageUser }}</h3>
                  <h3>เลขที่ตำแหน่ง : {{ user.id_position }}</h3>
                  <h3>สาขาวิชา : {{ user.pt_id_branch }}</h3>
                  <h3>สังกัด (สถานศึกษา) : {{ user.college_name }}</h3>
                  <h3 class="primary--text">
                    ตำแหน่ง : {{ user.position_name }}
                  </h3>
                  <h3>
                    วันที่เริ่มปฏิบัติหน้าที่ :
                    {{ date_appoin_ch || "-" }}
                  </h3>
                  <h3 class="info--text">ระยะเวลา : {{ get_gov_Age }}</h3>
                </v-alert>
              </v-col>

              <v-col cols="12" md="6">
                <v-alert
                  border="left"
                  colored-border
                  color="success darken-1"
                  elevation="2"
                  type="info"
                  class="flex-card"
                >
                  <h2>
                    ครั้งที่ : {{ periods.period_times }} ประจำปี :
                    {{ periods.period_year }}
                  </h2>
                  <h3>เขียนที่ : {{ user.user_firstname }}</h3>
                  <h3>วันที่ยื่นคำร้อง : {{ date_today }}</h3>
                  <hr />
                  <div v-if="user.date_app_now === ''">
                    <v-alert prominent type="error">
                      <v-row>
                        <v-col class="grow">
                          <h3>
                            ให้งานบุคลากร วิทยาลัย
                            ดำเนินการเกี่ยวกับวันที่ปฏิบัติงาน ณ
                            สถานศึกษาปัจจุบันให้เรียบร้อย
                          </h3>
                        </v-col>
                      </v-row>
                    </v-alert>
                  </div>
                  <div v-else>
                    <h3>
                      วันที่เริ่มปฏิบัติหน้าที่ในสถานศึกษาปัจจุบัน :
                      {{
                        user.date_app_now
                          | moment("add", "543 years")
                          | moment("D MMMM YYYY")
                      }}
                    </h3>
                    <h2 class="info--text">
                      ปฏิบัติหน้าที่เป็นเวลา : {{ get_Appoint_Age }}
                    </h2>
                  </div>
                </v-alert>
              </v-col>
            </v-row>
          </div>

          <v-stepper v-model="steps" vertical>
            <!-- ขั้นตอนที่ 1: ข้อมูลพื้นฐาน -->
            <v-stepper-step :complete="steps > 1" step="1">
              <div>
                ข้อมูลพื้นฐาน
                <small> ข้อมูลเบื้องต้น รหัสรายการอ้างอิง {{ id_ref }}</small>
                <v-btn
                  icon
                  rounded
                  color="secondary"
                  target="_blank"
                  @click="previewReportShow()"
                >
                  <v-icon class="pr-2">mdi-eye</v-icon>
                </v-btn>
              </div>
            </v-stepper-step>

            <v-stepper-content step="1">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-alert
                    border="left"
                    colored-border
                    color="success darken-1"
                    elevation="2"
                    type="info"
                  >
                    <v-card>
                      <v-card-title class="mt-8">
                        <v-avatar size="56">
                          <v-icon large left>mdi-cast-education</v-icon>
                        </v-avatar>
                        <p class="ml-3">ประวัติการศึกษา</p>
                      </v-card-title>

                      <v-card-text>
                        <v-timeline align-top dense>
                          <v-timeline-item
                            v-for="item in personnel_educations"
                            :key="item.id_red"
                            small
                          >
                            <div>
                              <div class="font-weight-normal">
                                {{ item.education_level }} คณะวิชา :
                                {{ item.faculty_name }} สาขาวิชา :
                                {{ item.branch_name }} สำเร็จปีการศึกษา :
                                {{ item.year_finish }}
                              </div>
                            </div>
                          </v-timeline-item>
                        </v-timeline>
                      </v-card-text>
                    </v-card>
                  </v-alert>
                </v-col>
              </v-row>

              <v-btn @click="addtransference_personnelSubmit()" color="primary">
                ดำเนินการถัดไป
              </v-btn>
            </v-stepper-content>

            <!-- ขั้นตอนที่ 2: เลือกหน่วยงาน -->
            <v-stepper-step :complete="steps > 2" step="2">
              <div>
                ประสงค์ขอย้ายไปปฏิบัติงาน (ระบุได้เพียงกรณีเดียว)
                <v-btn
                  icon
                  rounded
                  color="secondary"
                  target="_blank"
                  @click="previewReportShow()"
                >
                  <v-icon class="pr-2">mdi-eye</v-icon>
                </v-btn>
              </div>
            </v-stepper-step>

            <v-stepper-content step="2">
              <v-card>
                <v-row>
                  <v-alert
                    class="mx-auto justify-center pa-2 ma-2"
                    border="bottom"
                    colored-border
                    type="warning"
                    elevation="2"
                  >
                    <v-radio-group
                      row
                      v-model="transference_personnels.case_moves"
                      @change="clear_move()"
                    >
                      <v-radio value="0">
                        <template v-slot:label>
                          <div>
                            <strong
                              class="primary--text"
                              v-on:click="clear_move()"
                              >กรณีย้ายไปตำแหน่งว่าง</strong
                            >
                          </div>
                        </template>
                      </v-radio>
                      <v-radio value="1">
                        <template v-slot:label>
                          <div>
                            <strong
                              class="warning--text"
                              v-on:click="clear_move()"
                              >กรณีขอย้ายสับเปลี่ยน</strong
                            >
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-alert>
                </v-row>

                <v-col cols="12">
                  <v-row>
                    <v-col
                      cols="12"
                      v-if="transference_personnels.case_moves === '0' || transference_personnels.case_moves === 0"
                    >
                      <v-card class="px-5 py-3" color="#FADBD8">
                        <v-btn
                          class="ma-2"
                          x-large
                          color="success"
                          dark
                          rounded
                          @click.stop="addtransference_locationdialogsubmit()"
                        >
                          <v-icon>mdi-selection-multiple-marker</v-icon>
                          <span> เลือกหน่วยงานแห่งใหม่</span>
                        </v-btn>
                        <v-data-table
                          color="success"
                          :loading="loading"
                          :headers="header_trans"
                          :items="transference_locations"
                        >
                          <template v-slot:item.user_firstname="{ item }">
                            <span class="font-weight-bold">
                              {{
                                item.user_firstname + " " + item.user_lastname
                              }}
                            </span>
                          </template>
                          <template v-slot:item.name_branch="{ item }">
                            <span
                              class="font-weight-bold"
                              v-if="
                                user.position_name ===
                                  'พนักงานบริหารทั่วไป (ครู)'
                              "
                            >
                              {{ item.tlid_branch + " : " + item.name_branch }}
                            </span>
                            <span v-else>
                              {{ user.position_name }}
                            </span>
                          </template>
                          <template v-slot:item.action="{ item }">
                            <v-icon
                              color="error"
                              @click.stop="
                                transference_locationDelete(item.id_tfl)
                              "
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-col>

                    <v-col
                      cols="12"
                      v-if="transference_personnels.case_moves === '1' || transference_personnels.case_moves === 1"
                    >
                      <v-row>
                        <!-- ส่วนสับเปลี่ยน -->
                        <v-col cols="12">
                          <h3>
                            ขอย้ายสับเปลี่ยนกับ :
                            {{ personnel_temporarys.title_s }}
                            {{ personnel_temporarys.frist_name }}
                            {{ personnel_temporarys.last_name }}
                          </h3>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="transference_personnels.switch_position"
                            :counter="13"
                            outlined
                            label="บัตรประชาชน"
                            prepend-icon="mdi-account-details"
                            @input="OnEnterUpdate()"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-text-field
                            :value="personnel_temporarys.position_name"
                            outlined
                            label="ตำแหน่ง :"
                            prepend-icon="mdi-account-star"
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-text-field
                            :value="personnel_temporarys.ed_name"
                            outlined
                            label="วุฒิการศึกษา :"
                            prepend-icon="mdi-account-details"
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-text-field
                            :value="personnel_temporarys.id_position"
                            outlined
                            label="เลขที่ตำแหน่ง :"
                            prepend-icon="mdi-account-details"
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-text-field
                            :value="personnel_temporarys.college_name"
                            outlined
                            label="สังกัด :"
                            prepend-icon="mdi-flag-variant"
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <h3 class="error--text">
                            *
                            กรณีย้ายสับเปลี่ยนให้กรอกหมายเลขบัตรประจำตัวประชาชนของผู้ที่ท่านประสงค์สับเปลี่ยน
                            และกดปุ่ม Enter เพื่อดำเนินการค้นหา
                            หากไม่ปรากฏแสดงว่าไม่มีบุคคลดังกล่าวในระบบ
                          </h3>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-card>

              <v-btn
                v-if="checkEventAss != 0"
                color="primary"
                @click="updatetransference_personnelsSubmit(2)"
              >
                ดำเนินการขั้นตอนถัดไป
              </v-btn>

              <v-btn
                text
                outlined
                color="warning"
                @click="updatetransference_personnelsSubmit(1)"
              >
                ยกเลิก
              </v-btn>
            </v-stepper-content>

            <v-stepper-step :complete="steps > 3" step="3">
              <div>
                วินัย/คดีความ
                <v-btn
                  icon
                  rounded
                  color="secondary"
                  target="_blank"
                  @click="previewReportShow()"
                  ><v-icon class="pr-2">mdi-eye</v-icon>
                </v-btn>
              </div>
            </v-stepper-step>

            <v-stepper-content step="3">
              <v-card class="pa-2">
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-row>
                      <v-alert
                        class="mx-auto justify-center pa-2 ma-2"
                        border="bottom"
                        colored-border
                        type="warning"
                        elevation="2"
                      >
                        <v-radio-group
                          row
                          v-model="transference_personnels.tp_discipline"
                        >
                          <v-radio value="1">
                            <template v-slot:label>
                              <div>
                                <strong class="error--text"
                                  >เคยถูกลงโทษทางวินัย</strong
                                >
                              </div>
                            </template>
                          </v-radio>
                          <v-radio value="0">
                            <template v-slot:label>
                              <div>
                                <strong class="success--text"
                                  >ไม่เคยถูกลงโทษทางวินัย</strong
                                >
                              </div>
                            </template>
                          </v-radio>
                        </v-radio-group>

                        <v-radio-group
                          row
                          v-model="transference_personnels.tp_pro_discipline"
                        >
                          <v-radio value="1">
                            <template v-slot:label>
                              <div>
                                <strong class="error--text"
                                  >อยู่ในระหว่างถูกดำเนินการทางวินัย</strong
                                >
                              </div>
                            </template>
                          </v-radio>
                          <v-radio value="0">
                            <template v-slot:label>
                              <div>
                                <strong class="success--text"
                                  >ไม่อยู่ในระหว่างถูกดำเนินการทางวินัย</strong
                                >
                              </div>
                            </template>
                          </v-radio>
                        </v-radio-group>

                        <v-radio-group
                          row
                          v-model="transference_personnels.tp_criminal"
                        >
                          <v-radio value="1">
                            <template v-slot:label>
                              <div>
                                <strong class="error--text"
                                  >อยู่ในระหว่างถูกดำเนินคดีอาญา</strong
                                >
                              </div>
                            </template>
                          </v-radio>
                          <v-radio value="0">
                            <template v-slot:label>
                              <div>
                                <strong class="success--text"
                                  >ไม่อยู่ในระหว่างถูกดำเนินคดีอาญา</strong
                                >
                              </div>
                            </template>
                          </v-radio>
                        </v-radio-group>

                        <v-radio-group
                          row
                          v-model="transference_personnels.tp_bankrupt"
                        >
                          <v-radio value="1">
                            <template v-slot:label>
                              <div>
                                <strong class="error--text"
                                  >อยู่ในระหว่างถูกดำเนินคดีล้มละลาย</strong
                                >
                              </div>
                            </template>
                          </v-radio>
                          <v-radio value="0">
                            <template v-slot:label>
                              <div>
                                <strong class="success--text"
                                  >ไม่อยู่ในระหว่างถูกดำเนินคดีล้มละลาย</strong
                                >
                              </div>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </v-alert>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
              <v-btn
                color="primary"
                @click="updatetransference_personnelsSubmit((step = 3))"
              >
                ดำเนินการขั้นตอนถัดไป
              </v-btn>
              <v-btn
                text
                outlined
                color="warning"
                @click="updatetransference_personnelsSubmit((step = 1))"
              >
                ยกเลิก
              </v-btn>
            </v-stepper-content>

            <!-- ผลการประเมิน 4-->
            <v-stepper-step :complete="steps > 4" step="4">
              <div>
                ผลการประเมินการปฏิบัติงานย้อนหลัง
                <v-btn
                  icon
                  rounded
                  color="secondary"
                  target="_blank"
                  @click="previewReportShow()"
                >
                  <v-icon class="pr-2">mdi-eye</v-icon>
                </v-btn>
              </div>
            </v-stepper-step>

            <v-stepper-content step="4">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-alert
                    border="left"
                    colored-border
                    color="success darken-1"
                    elevation="2"
                    type="info"
                  >
                    <v-card>
                      <v-card-title class="mt-8">
                        <v-avatar size="56">
                          <v-icon large left>mdi-cast-education</v-icon>
                        </v-avatar>
                        <p class="ml-3">ผลการประเมินการปฏิบัติงานย้อนหลัง</p>
                      </v-card-title>

                      <v-card-text>
                        <v-timeline align-top dense>
                          <v-timeline-item
                            v-for="item in personnel_govem_assesment"
                            :key="item.id_red"
                            small
                          >
                            <div>
                              <div class="font-weight-normal">
                                {{ item.govem_assesment_timeyear }} ระดับ :
                                {{ item.govem_assesment_level }} คะแนน :
                                {{ item.govem_assesment_score }} วันที่ประเมิน :
                                {{ item.personnel_govem_assesment_dateitem }}
                              </div>
                            </div>
                          </v-timeline-item>
                        </v-timeline>
                      </v-card-text>
                    </v-card>
                  </v-alert>
                </v-col>
              </v-row>

              <v-btn
                color="primary"
                @click="updatetransference_personnelsSubmit((step = 4))"
              >
                ดำเนินการขั้นตอนถัดไป
              </v-btn>
              <v-btn
                text
                outlined
                color="warning"
                @click="updatetransference_personnelsSubmit((step = 2))"
              >
                ยกเลิก
              </v-btn>
            </v-stepper-content>

            <!--ผลงานดีเด่นจากการปฏิบัติงาน จำนวน 1 เรื่อง (บรรยายไม่เกิน 1 หน้า กระดาษ A4)-->
            <v-stepper-step :complete="steps > 5" step="5">
              <div>
                ผลงานดีเด่นจากการปฏิบัติงาน จำนวน 1 เรื่อง (บรรยายไม่เกิน 1 หน้า
                กระดาษ A4)
                <v-btn
                  icon
                  rounded
                  color="secondary"
                  target="_blank"
                  @click="previewReportShow()"
                >
                  <v-icon class="pr-2">mdi-eye</v-icon>
                </v-btn>
              </div>
            </v-stepper-step>

            <v-stepper-content step="5">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-alert
                    border="left"
                    colored-border
                    color="success darken-1"
                    elevation="2"
                    type="info"
                  >
                    <v-card>
                      <v-card-title class="mt-8">
                        <v-avatar size="56">
                          <v-icon large left>mdi-cast-education</v-icon>
                        </v-avatar>
                        <p class="ml-3">
                          ผลงานดีเด่นจากการปฏิบัติงาน จำนวน 1 เรื่อง
                          (บรรยายไม่เกิน 1 หน้า กระดาษ A4)
                        </p>
                      </v-card-title>

                      <v-card-text>
                        <v-textarea
                          v-model="transference_personnels.tp_knowleage"
                          :rules="[v => !!v || '']"
                          background-color="warning lighten-4"
                          color="warning orange-darken-4"
                          rows="10"
                          row-height="30"
                          label="(ระบุ) : "
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                  </v-alert>
                </v-col>
              </v-row>

              <v-btn
                v-if="transference_personnels.tp_knowleage"
                color="primary"
                @click="updatetransference_personnelsSubmit((step = 5))"
              >
                ดำเนินการขั้นตอนถัดไป
              </v-btn>
              <v-btn
                text
                outlined
                color="warning"
                @click="updatetransference_personnelsSubmit((step = 2))"
              >
                ยกเลิก
              </v-btn>
            </v-stepper-content>

            <!-- ขั้นตอนที่ 6: เหตุผลการขอย้าย -->
            <v-stepper-step :complete="steps > 6" step="6">
              <div>
                เหตุผลการขอย้าย
                <v-btn
                  icon
                  rounded
                  color="secondary"
                  target="_blank"
                  @click="previewReportShow()"
                >
                  <v-icon class="pr-2">mdi-eye</v-icon>
                </v-btn>
              </div>
            </v-stepper-step>

            <v-stepper-content step="6">
              <v-col cols="12">
                <v-card class="pa-2">
                  <v-card-text>
                    <!-- เหตุผลการย้าย 1: อยู่ร่วมคู่สมรส -->
                    <v-row align="center">
                      <v-card-title>
                        <div class="font-weight-light v-size--x-large">
                          ย้ายเพื่ออยู่ร่วมคู่สมรส
                        </div>
                      </v-card-title>
                      <v-checkbox
                        v-model="transference_personnels.reason_1"
                        value="1"
                        hide-details
                        class="shrink mr-2 mt-0"
                      ></v-checkbox>
                      <v-text-field
                        v-model="transference_personnels.reason_1_spouse"
                        :disabled="!transference_personnels.reason_1"
                        label="คู่สมรสชื่อ : "
                      ></v-text-field>
                      <v-text-field
                        v-model="transference_personnels.reason_1_occupation"
                        :disabled="!transference_personnels.reason_1"
                        label="คู่สมรสประกอบอาชีพ : "
                      ></v-text-field>
                      <v-text-field
                        v-model="transference_personnels.reason_1_location"
                        :disabled="!transference_personnels.reason_1"
                        label="สถานที่ประกอบอาชีพของคู่สมรส : "
                      ></v-text-field>
                      <!-- DropDown สำหรับจังหวัด อำเภอ ตำบล -->
                      <v-autocomplete
                        v-model="transference_personnels.reason_1_domicile"
                        :items="provinces1"
                        item-text="province_name"
                        item-value="province_ID"
                        :disabled="!transference_personnels.reason_1"
                        label="ภูมิลำเนาของคู่สมรส จังหวัด : "
                      ></v-autocomplete>
                      <v-autocomplete
                        v-model="transference_personnels.reason_1_prefecture"
                        :items="prefectures1"
                        item-text="prefecture_name"
                        item-value="prefecture_ID"
                        :disabled="!transference_personnels.reason_1"
                        label="ภูมิลำเนาของคู่สมรส อำเภอ : "
                      ></v-autocomplete>
                      <v-autocomplete
                        v-model="transference_personnels.reason_1_district"
                        :items="district1"
                        item-text="district_name"
                        item-value="district_ID"
                        :disabled="!transference_personnels.reason_1"
                        label="ภูมิลำเนาของคู่สมรส ตำบล : "
                      ></v-autocomplete>
                      <!-- ข้อมูลบุตร -->
                      <v-text-field
                        v-model="transference_personnels.reason_1_child"
                        :disabled="!transference_personnels.reason_1"
                        label="บุตรชื่อ : "
                      ></v-text-field>
                      <v-text-field
                        v-model="transference_personnels.reason_1_childage"
                        :disabled="!transference_personnels.reason_1"
                        type="number"
                        label="อายุของบุตร ปี : "
                      ></v-text-field>
                    </v-row>

                    <!-- เหตุผลการย้าย 2: ดูแลบิดา มารดา -->
                    <v-row align="center">
                      <v-card-title>
                        <div class="font-weight-light v-size--x-large">
                          ย้ายเพื่อดูแลบิดา มารดา :
                        </div>
                      </v-card-title>
                      <v-checkbox
                        v-model="transference_personnels.reason_2"
                        value="1"
                        hide-details
                        class="shrink mr-2 mt-0"
                      ></v-checkbox>
                      <v-text-field
                        v-model="transference_personnels.reason_2_fyear"
                        :disabled="!transference_personnels.reason_2"
                        label="อายุของบิดาปี (กรณีมีชีวิตอยู่)"
                      ></v-text-field>
                      <v-text-field
                        v-model="transference_personnels.reason_2_myear"
                        :disabled="!transference_personnels.reason_2"
                        label="อายุของมารดาปี (กรณีมีชีวิตอยู่)"
                      ></v-text-field>
                      <v-autocomplete
                        v-model="transference_personnels.reason_2_domicile"
                        :items="provinces2"
                        item-text="province_name"
                        item-value="province_ID"
                        :disabled="!transference_personnels.reason_2"
                        label="ภูมิลำเนาของบิดา มารดา จังหวัด : "
                      ></v-autocomplete>
                      <v-autocomplete
                        v-model="transference_personnels.reason_2_prefecture"
                        :items="prefectures2"
                        item-text="prefecture_name"
                        item-value="prefecture_ID"
                        :disabled="!transference_personnels.reason_2"
                        label="ภูมิลำเนาของบิดา มารดา อำเภอ : "
                      ></v-autocomplete>
                      <v-autocomplete
                        v-model="transference_personnels.reason_2_district"
                        :items="district2"
                        item-text="district_name"
                        item-value="district_ID"
                        :disabled="!transference_personnels.reason_2"
                        label="ภูมิลำเนาของบิดา มารดา ตำบล : "
                      ></v-autocomplete>
                      <div class="pl-5 error--text">
                        * กรณี บิดาหรือมารดา เสียชีวิต ระบุ 0 หรือ เว้นว่าง
                      </div>
                    </v-row>

                    <!-- เหตุผลการย้าย 3: กลับภูมิลำเนา -->
                    <v-row align="center">
                      <v-card-title>
                        <div class="font-weight-light v-size--x-large">
                          ย้ายกลับภูมิลำเนาของข้าพเจ้า จังหวัด :
                        </div>
                      </v-card-title>
                      <v-checkbox
                        v-model="transference_personnels.reason_3"
                        value="1"
                        hide-details
                        class="shrink mr-2 mt-0"
                      ></v-checkbox>
                      <v-autocomplete
                        v-model="transference_personnels.reason_3_domicile"
                        :items="provinces3"
                        item-text="province_name"
                        item-value="province_ID"
                        :disabled="!transference_personnels.reason_3"
                        label="ภูมิลำเนาของข้าพเจ้า จังหวัด : "
                      ></v-autocomplete>
                      <v-autocomplete
                        v-model="transference_personnels.reason_3_prefecture"
                        :items="prefectures3"
                        item-text="prefecture_name"
                        item-value="prefecture_ID"
                        :disabled="!transference_personnels.reason_3"
                        label="ภูมิลำเนาของข้าพเจ้า อำเภอ : "
                      ></v-autocomplete>
                      <v-autocomplete
                        v-model="transference_personnels.reason_3_district"
                        :items="district3"
                        item-text="district_name"
                        item-value="district_ID"
                        :disabled="!transference_personnels.reason_3"
                        label="ภูมิลำเนาของข้าพเจ้า ตำบล : "
                      ></v-autocomplete>
                    </v-row>

                    <!-- เหตุผลการย้าย 4: อื่นๆ -->
                    <v-row align="center">
                      <v-card-title>
                        <div class="font-weight-light v-size--x-large">
                          เหตุผลอื่น :
                        </div>
                      </v-card-title>
                      <v-checkbox
                        v-model="transference_personnels.reason_4"
                        value="1"
                        hide-details
                        class="shrink mr-2 mt-0"
                      ></v-checkbox>
                      <v-textarea
                        v-model="transference_personnels.reason_4_detail"
                        :disabled="!transference_personnels.reason_4"
                        label="(ระบุ) : "
                      ></v-textarea>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-btn
                color="primary"
                @click="updatetransference_personnelsSubmit(6)"
              >
                ดำเนินการขั้นตอนถัดไป
              </v-btn>
              <v-btn
                text
                outlined
                color="warning"
                @click="updatetransference_personnelsSubmit(4)"
              >
                ยกเลิก
              </v-btn>
            </v-stepper-content>

            <!-- ขั้นตอนที่ 7: เอกสารประกอบ -->
            <v-stepper-step :complete="steps > 7" step="7">
              <div>
                เอกสารหลักฐานต่าง ๆ ที่ส่งเพื่อประกอบการพิจารณา
                โดยรับรองสำเนาตามระเบียบ สำนักนายกรัฐมนตรีว่าด้วยงานสารบรรณ
                ดังนี้
                <v-btn
                  icon
                  rounded
                  color="secondary"
                  target="_blank"
                  @click="previewReportShow()"
                >
                  <v-icon class="pr-2">mdi-eye</v-icon>
                </v-btn>
              </div>
            </v-stepper-step>

            <v-stepper-content step="7">
              <v-row>
                <v-col cols="12">
                  <v-row class="pa-4 mt-0">
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="transference_personnels.evidence_info_1"
                        label="สำเนาสัญญาจ้าง ที่มีรายละเอียดครบถ้วน ตั้งแต่วันที่เริ่มสัญญาจ้าง"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="transference_personnels.evidence_info_2"
                        label="สำเนาทะเบียนบ้าน"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="transference_personnels.evidence_info_3"
                        label="สำเนาปริญญาบัตร หรือเอกสารหลักฐานอื่นที่แสดงการสำเร็จการศึกษา"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="transference_personnels.evidence_info_4"
                        label="สำเนาระเบียนแสดงผลการศึกษา (Transcript)"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="transference_personnels.evidence_info_5"
                        label="สำเนาเอกสารหลักฐานที่แสดงถึงผลประเมินการปฏิบัติงาน 2 ครั้งล่าสุด (แบบ ปผ.พนร. 1-3)"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="transference_personnels.evidence_info_6"
                        label="สำเนาเอกสารหลักฐานที่แสดงถึงความรู้ความสามารถพิเศษ ที่เป็นประโยชน์ต่อการปฏิบัติงาน"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="transference_personnels.evidence_info_7"
                        label="สำเนาเอกสารหลักฐานอื่นที่เกี่ยวข้อง เช่น หนังสือสำคัญการเปลี่ยนชื่อ - สกุล ใบรับรองแพทย์ ใบสำคัญการสมรส เป็นต้น (ถ้ามี)"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                        v-model="transference_personnels.evidence_info_8"
                        label="เอกสารหลักฐานอื่นที่เป็นประโยชน์ต่อการพิจารณาการย้าย"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-btn
                color="primary"
                @click="updatetransference_personnelsSubmit(7)"
              >
                ดำเนินการขั้นตอนถัดไป
              </v-btn>
              <v-btn
                text
                outlined
                color="warning"
                @click="updatetransference_personnelsSubmit(5)"
              >
                ยกเลิก
              </v-btn>
            </v-stepper-content>

            <!-- ขั้นตอนที่ 8: ยืนยันความประสงค์ -->
            <v-stepper-step :complete="steps > 8" step="8">
              <div>
                ยืนยันความประสงค์ยืนย้าย
                <v-btn
                  icon
                  rounded
                  color="secondary"
                  target="_blank"
                  @click="previewReportShow()"
                >
                  <v-icon class="pr-2">mdi-eye</v-icon>
                </v-btn>
              </div>
            </v-stepper-step>

            <v-stepper-content step="8">
              <div>
                <div class="text-center">
                  <h3 class="error--text">
                    * เมื่อกดปุ่มบันทึกและยืนยันข้อมูลแล้ว
                    ท่านจะไม่สามารถแก้ไขข้อมูลใดๆ ได้
                    กรุณาตรวจสอบข้อมูลให้ถูกต้องการกดปุ่ม บันทึก
                  </h3>
                  <h2 class="success--text">
                    * เมื่อกดปุ่มบันทึกแล้วจะปรากฎปุ่มสำหรับพิมพ์แบบเสนอขอย้าย
                  </h2>
                  <v-btn
                    rounded
                    x-large
                    color="secondary"
                    target="_blank"
                    @click="previewReportShow()"
                  >
                    <v-icon class="pr-2">mdi-eye</v-icon>
                    แบบฟอร์มตัวอย่างคำร้องขอย้าย
                  </v-btn>
                </div>
              </div>

              <v-btn color="primary" @click="confirmsSubmit()">
                ยืนยันความประสงค์ยืนย้าย
              </v-btn>
              <v-btn
                text
                outlined
                color="warning"
                @click="updatetransference_personnelsSubmit(4)"
              >
                ยกเลิก
              </v-btn>
            </v-stepper-content>

            <!-- ขั้นตอนที่ 12: ดาวน์โหลดเอกสาร -->
            <v-stepper-step step="12">
              ดาวน์โหลดเอกสารประกอบการพิจารณา
            </v-stepper-step>

            <v-stepper-content step="12">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="pa-2 ma-2">
                    <v-card-title>
                      <div class="font-weight-bold v-size--x-large">
                        <v-icon large left>mdi-file-document</v-icon>
                        แบบคำร้องขอย้ายพนักงานราชการประเภททั่วไป
                        สังกัดสำนักงานคณะกรรมการการอาชีวศึกษา
                      </div>
                    </v-card-title>
                    <v-card-text>
                      <v-btn
                        rounded
                        color="info"
                        dark
                        class="ma-2"
                        :href="'#/user/print_info_govem/?id_ref=' + id_ref"
                        target="_blank"
                      >
                        <v-icon>mdi-printer</v-icon>
                        <span>พิมพ์แบบแสดงความประสงค์ขอย้าย</span>
                      </v-btn>
                      <div class="error--text font-weight-bold">
                        * แบบคำร้องขอย้ายพนักงานราชการประเภททั่วไป
                        และดำเนินการจัดทำ
                        เพื่อเสนอความเห็นชอบจากผู้บริหารสถานศึกษา และให้
                        สถานศึกษาดำเนินการสแกนไฟล์ แนบผ่านระบบขนาดไม่เกิน 5MB
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-stepper-content>
          </v-stepper>
        </base-material-card>

        <!-- Dialogs -->
        <!-- Preview Report Dialog -->
        <v-dialog v-model="previewReport" width="80%">
          <v-card>
            <iframe
              style="width:100%; height: 600px;"
              :src="'#/user/print_info_preview_govem/?id_ref=' + id_ref"
            ></iframe>
          </v-card>
        </v-dialog>

        <!-- Add Location Dialog -->
        <v-dialog
          v-model="addtransference_locationdialog"
          persistent
          max-width="80%"
        >
          <v-card class="mx-auto pa-5">
            <base-material-card
              icon="mdi-account-multiple"
              title="เลือก ปลายทางการย้าย"
              class="px-5 py-3"
            >
              รหัสรายการอ้างอิง {{ id_ref }}
            </base-material-card>
            <v-card-text>
              <v-form ref="addtransference_locationform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md4>
                      <v-select
                        v-model="addtransference_location.tlsequence_n"
                        :items="order_need"
                        outlined
                        label="ลำดับที่ :"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex md8>
                      <v-autocomplete
                        v-model="addtransference_location.tlcollege_code"
                        :items="users"
                        item-text="user_firstname"
                        item-value="user_code"
                        outlined
                        label="สังกัด :"
                        prepend-icon="mdi-flag-variant"
                        :rules="[v => !!v || '']"
                        @change="loadveccentral()"
                      >
                        <template v-slot:item="{ item }">
                          <div>
                            <div class="font-weight-bold">
                              {{
                                item.user_firstname + " " + item.user_lastname
                              }}
                            </div>
                          </div>
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <v-flex md12 v-if="veccentral.length > 1">
                      <v-autocomplete
                        v-model="addtransference_location.tlcollege_department"
                        :items="veccentral"
                        item-text="namegroup"
                        item-value="namegroup"
                        outlined
                        label="สังกัด หน่วยกลุ่ม ศูนย์ :"
                        prepend-icon="mdi-flag-variant"
                        :rules="[v => !!v || '']"
                      >
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-container>
                <small>* จำเป็น</small>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="warning"
                large
                @click.stop="addtransference_locationdialog = false"
              >
                <v-icon dark>mdi-close</v-icon> ยกเลิก
              </v-btn>
              <v-btn
                large
                color="success"
                @click.stop="addtransference_locationSubmit()"
              >
                <v-icon dark>mdi-content-save</v-icon>&nbsp;&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Delete Location Dialog -->
        <v-dialog
          v-model="delettransference_locationdialog"
          persistent
          max-width="40%"
        >
          <v-card class="mx-auto pa-5">
            <base-material-card
              color="error"
              icon="mdi-delete"
              title="ลบรายการ"
              class="px-5 py-3"
            >
            </base-material-card>
            <v-card-text>
              <v-card>
                <v-card-text>
                  <v-form ref="deletetransference_locationform" lazy-validation>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12>
                          ยืนยันการลบ
                          <span>{{
                            edittransference_location.college_name
                          }}</span>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                large
                @click.stop="delettransference_locationdialog = false"
              >
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="error darken-3"
                @click.stop="deletetransference_locationSubmit()"
                dark
              >
                <v-icon dark>mdi-delete</v-icon>&nbsp;ลบ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Confirm Dialog -->
        <v-dialog v-model="confirm_dialog" persistent max-width="40%">
          <v-card class="mx-auto pa-5">
            <base-material-card
              color="primary"
              icon="mdi-content-save"
              title="ยืนยันรายการ"
              class="px-5 py-3"
            >
            </base-material-card>
            <v-card-text>
              <v-card>
                <v-card-text>
                  <v-form ref="deletetransference_locationform" lazy-validation>
                    <v-container grid-list-md>
                      <v-alert outlined type="error" prominent border="left">
                        <h2>เตือน</h2>
                        <h3>
                          หากกดปุ่มบันทึกท่านไม่สามารถ แก้ไขข้อมูลใดๆ ได้แล้ว
                          กรุณาตรวจสอบให้ถูกต้องก่อนการบันทึก
                        </h3>
                      </v-alert>
                    </v-container>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large rounded @click.stop="confirm_dialog = false">
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="primary"
                @click.stop="updatetransference_personnelsSaveSubmit()"
                dark
                rounded
              >
                <v-icon dark>mdi-content-save</v-icon>&nbsp;ยืนยันส่งคำร้อง
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      top
      :timeout="snackbar.timeout"
      :color="snackbar.color"
    >
      <v-icon large>{{ snackbar.icon }}</v-icon>
      <v-card-text>{{ snackbar.text }}</v-card-text>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import FlipCountdown from "vue2-flip-countdown";

export default {
  name: "HrvecTransferencePersonnel",
  components: { FlipCountdown },

  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",
      steps: 1,

      // Core Data
      user: {},
      periods: [],
      transference_personnels: {},
      transference_locations: [],
      personnel_educations: [],
      personnel_education_check: [],
      personnel_temporarys: [],

      // Form Data
      addtransference_location: {},
      edittransference_location: [],

      // Lists and Options
      users: [],
      branch_s: [],
      order_need: [1, 2, 3],

      // Geographic Data
      provinces1: [],
      provinces2: [],
      provinces3: [],
      prefectures1: [],
      prefectures2: [],
      prefectures3: [],
      district1: [],
      district2: [],
      district3: [],

      // UI State
      addtransference_locationdialog: false,
      delettransference_locationdialog: false,
      confirm_dialog: false,
      previewReport: false,

      // Table Headers
      header_trans: [
        { text: "ลำดับ", align: "center", value: "tlsequence_n" },
        { text: "รหัสอ้างอิง", align: "center", value: "tlid_ref" },
        { text: "สาขาวิชา/ตำแหน่ง", align: "center", value: "name_branch" },
        { text: "ปลายทาง", align: "center", value: "user_firstname" },
        {
          text: "สำนัก/หน่วย/กลุ่ม/ศูนย์",
          align: "center",
          value: "tlcollege_department"
        },
        { text: "ยกเลิก", align: "center", value: "action" }
      ],

      // Snackbar
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },

      // Countdown Labels
      labels: {
        days: "วัน",
        hours: "ชั่วโมง",
        minutes: "นาที",
        seconds: "วินาที"
      },

      personnel_govem_assesment: [],
      stats: [],
      veccentral: []
    };
  },

  async mounted() {
    await this.initializeDataFirst();
  },

  methods: {
    async clear_move() {
      let result = await this.$http.post(
        "transference_location.delete_idref.php",
        {
          ApiKey: this.ApiKey,
          tlid_ref: this.id_ref
        }
      );
      let result_sw = await this.$http.post(
        "transference_personnel.update.php",
        {
          ApiKey: this.ApiKey,
          id_tfp: this.transference_personnels.id_tfp,
          switch_position: "-"
        }
      );   
      if (result.data.status == true || result_sw.data.stats == true) {
        await this.initializeDataFirst();
      }
    },
    async initializeDataFirst() {
      try {
        let userSession = JSON.parse(localStorage.getItem("user")) || {};

        // Load basic data

        await this.loadUser(userSession.id_card),
          await this.loadPeriods(),
          await this.loadColleges(),
          await this.loadProvinces(),
          await this.loadBranches(),
          await this.loadUserEducation(userSession.id_card);
        await this.loadUserAssesment(userSession.id_card);

        // Validate user eligibility
        await this.validateUserEligibility();

        // Load transfer data
        await this.loadTransferData();
      } catch (error) {
        console.error("Initialization error:", error);
        this.showError("เกิดข้อผิดพลาดในการโหลดข้อมูล");
      }
    },

    async loadBranches() {
      const result = await this.$http.post("branch.php", {
        ApiKey: this.ApiKey
      });
      this.branch_s = result.data;
    },

    async loadColleges() {
      const result = await this.$http.post("user.php", {
        ApiKey: this.ApiKey,
        admin: "ok"
      });
      this.users = result.data;
    },

    async loadveccentral() {
      let user_reply = await this.$http.post("user.php", {
        ApiKey: this.ApiKey,
        user_code: this.addtransference_location.tlcollege_code
      });
      let user_reply_data = user_reply.data;
    
      if (user_reply_data.user_status == "V") {
        const result = await this.$http.post("veccentral.php", {
          ApiKey: this.ApiKey,
          idgroupdep: user_reply_data.veccentralDepID
        });
        this.veccentral = result.data;
      } else {
        this.veccentral = [];
      }
    },

    async loadUser(id_card) {
      const result = await this.$http.post("personnel_temporary.php", {
        ApiKey: this.ApiKey,
        id_card: id_card
      });
      this.user = result.data;
    },

    async loadProvinces() {
      const result = await this.$http.post("province.php");
      this.provinces1 = result.data;
      this.provinces2 = result.data;
      this.provinces3 = result.data;
    },

    async loadPeriods() {
      const result = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_id: "401"
      });
      this.periods = result.data;

      if (this.periods.period_enable !== "1") {
        this.redirectToProfile("ระบบได้ปิดทำการเสนอย้ายแล้วในขณะนี้");
      }
    },

    async loadUserEducation(id_card) {
      const [education, educationCheck] = await Promise.all([
        this.$http.post("personnel_education.php", {
          ApiKey: this.ApiKey,
          id_card: id_card
        }),
        this.$http.post("personnel_education.check.php", {
          ApiKey: this.ApiKey,
          id_card: id_card
        })
      ]);

      this.personnel_educations = education.data;
      this.personnel_education_check = educationCheck.data;
    },

    async loadUserAssesment(id_card) {
      try {
        let result = await this.$http.post("personnel_govem_assesment.php", {
          ApiKey: this.ApiKey,
          personnel_govem_assesment_idcard: id_card
        });
        ;
        // ดึงข้อมูลทั้งหมด
        let allData = result.data || [];

        // ตรวจสอบว่ามีข้อมูลหรือไม่
        if (!allData || allData.length === 0) {
          this.personnel_govem_assesment = [];
          this.redirectToProfile(
            "ไม่พบข้อมูลการประเมินผลการปฏิบัติงาน กรุณาปรับปรุงผลการประเมิน และ ผลการประเมินต้องปรากฎ 2 ครั้งติดต่อกัน"
          );
          return;
        }

        // เรียงลำดับตามปีและครั้งที่ (DESC) - ล่าสุดก่อน
        const sortedData = allData.sort((a, b) => {
          // แปลง govem_assesment_timeyear จาก "1/2568" เป็นการเปรียบเทียบ
          const parseTimeYear = timeYear => {
            if (!timeYear) return { time: 0, year: 0 };
            const parts = timeYear.split("/");
            return {
              time: parseInt(parts[0]) || 0,
              year: parseInt(parts[1]) || 0
            };
          };

          const aData = parseTimeYear(a.govem_assesment_timeyear);
          const bData = parseTimeYear(b.govem_assesment_timeyear);

          // เรียงตามปีก่อน (DESC)
          if (bData.year !== aData.year) {
            return bData.year - aData.year;
          }
          // ถ้าปีเดียวกัน เรียงตามครั้งที่ (DESC)
          return bData.time - aData.time;
        });

        // ดึงเฉพาะ 2 รายการล่าสุด
        const latest2Records = sortedData.slice(0, 2);

        // เก็บข้อมูลทั้งหมดและข้อมูล 2 รายการล่าสุด
        this.personnel_govem_assesment = allData; // ข้อมูลทั้งหมด
        this.latest2Assessments = latest2Records; // ข้อมูล 2 รายการล่าสุด

        // ตรวจสอบเงื่อนไข
        if (latest2Records.length < 2) {
          this.redirectToProfile(
            `ต้องมีคะแนนเฉลี่ยผลการประเมินปฏิบัติงาน 2 ครั้งล่าสุด ติดต่อกันไม่ต่ำกว่าระดับดี (ปัจจุบันมีเพียง ${latest2Records.length} รายการ)`
          );
          return;
        }

        // ตรวจสอบคะแนนระดับดี (สมมติว่าคะแนนดีต้อง >= 75)
        const isGoodLevel = score => {
          // ปรับเงื่อนไขตามระบบของคุณ
          return parseFloat(score) >= 75; // หรือเงื่อนไขอื่นๆ
        };

        const allGoodLevel = latest2Records.every(record =>
          isGoodLevel(record.govem_assesment_score || 0)
        );

        if (!allGoodLevel) {
          this.redirectToProfile(
            "คะแนนเฉลี่ยผลการประเมินปฏิบัติงาน 2 ครั้งล่าสุด ต้องติดต่อกันไม่ต่ำกว่าระดับดี"
          );
          return;
        }

        // ตรวจสอบความต่อเนื่อง (เช่น ครั้งที่ 1/2568 และ 2/2567)
        if (latest2Records.length === 2) {
          const isConsecutive = this.checkConsecutiveAssessments(
            latest2Records
          );
          if (!isConsecutive) {
            this.redirectToProfile(
              "การประเมินปฏิบัติงาน 2 ครั้งล่าสุด ต้องเป็นการประเมินที่ติดต่อกัน"
            );
            return;
          }
        }


      } catch (error) {
        console.error("Error loading assessment:", error);
        this.redirectToProfile(
          "เกิดข้อผิดพลาดในการโหลดข้อมูลการประเมิน กรุณาลองใหม่อีกครั้ง"
        );
      }
    },

    checkConsecutiveAssessments(assessments) {
      if (assessments.length !== 2) return false;

      const parseTimeYear = timeYear => {
        const parts = timeYear.split("/");
        return {
          time: parseInt(parts[0]),
          year: parseInt(parts[1])
        };
      };

      const first = parseTimeYear(assessments[0].govem_assesment_timeyear);
      const second = parseTimeYear(assessments[1].govem_assesment_timeyear);

      // ตรวจสอบความต่อเนื่อง
      // กรณีที่ 1: ปีเดียวกัน ครั้งที่ต่อเนื่อง (เช่น 2/2568 และ 1/2568)
      if (first.year === second.year) {
        return Math.abs(first.time - second.time) === 1;
      }

      // กรณีที่ 2: ต่างปี แต่ต่อเนื่อง (เช่น 1/2568 และ 2/2567)
      if (Math.abs(first.year - second.year) === 1) {
        // ถ้าปีใหม่กว่า ครั้งที่ต้องเป็น 1, ปีเก่ากว่า ครั้งที่ต้องเป็นครั้งสุดท้าย
        const newerAssessment = first.year > second.year ? first : second;
        const olderAssessment = first.year > second.year ? second : first;

        return newerAssessment.time === 1 && olderAssessment.time >= 1;
      }

      return false;
    },

    async validateUserEligibility() {
      // Check assistant teacher position
      if (this.user.position_name === "ครูผู้ช่วย") {
        this.redirectToProfile(
          "ท่านขาดคุณสมบัติในการย้าย ท่านอยู่ในระหว่างการเตรียมความพร้อมและพัฒนาอย่างเข้มของข้าราชการครูและบุคลากรทางการศึกษา แหน่งครูผู้ช่วย"
        );
        return;
      }

      // Check local development teacher conditions
      if (
        this.user.type_personnel === "local_dev" &&
        this.get_gov_Age_year < 5
      ) {
        this.redirectToProfile(
          "ท่านต้องมีเงือนไขในการย้ายสำหรับครูโครงการพัฒนาท้องถิ่นครบตามกำหนด"
        );
        return;
      }

      // Check service years
      if (this.get_gov_Age_year < 1) {
        this.redirectToProfile(
          "คุณสมบัติของผู้ขอย้าย จะต้องดำรงตำแหน่งในหน่วยงานการศึกษาปัจจุบันไม่น้อยกว่า 12 เดือน"
        );
        return;
      }

      // Check education data
      if (this.personnel_education_check.count_ed === "0") {
        this.redirectToProfile(
          "ให้ดำเนินการบันทึกข้อมูลคุณวุฒิการศึกษาของท่านเรียบร้อย",
          "/personnel_education"
        );
        return;
      }
    },

    async loadTransferData() {
      await this.transference_personnelAll();
      await this.transference_locationQueryAll();
    },

    redirectToProfile(message, route = "/UserProfile") {
      Swal.fire({
        icon: "error",
        title: message,
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then(() => {
        this.$router.push(route);
      });
    },

    showError(message) {
      this.snackbar = {
        show: true,
        color: "error",
        icon: "mdi-alert",
        text: message
      };
    },

    showSuccess(message) {
      this.snackbar = {
        show: true,
        color: "success",
        icon: "mdi-check",
        text: message
      };
    },

    async previewReportShow() {
      this.previewReport = true;
    },

    async transference_personnelAll() {
      this.loading = true;
      try {
        const result = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          id_ref: this.id_ref
        });
        this.transference_personnels = result.data;

        const stepsep = this.transference_personnels.tp_steps;
        this.steps = stepsep >= 1 ? parseInt(stepsep) + 1 : 1;
      } catch (error) {
        console.error("Error loading transfer personnel:", error);
      } finally {
        this.loading = false;
      }
    },

    async transference_locationQueryAll() {
      try {
        const result = await this.$http.post("transference_location.php", {
          ApiKey: this.ApiKey,
          id_ref: this.id_ref
        });
        this.transference_locations = result.data;
      } catch (error) {
        console.error("Error loading transfer locations:", error);
      }
    },

    async addtransference_locationdialogsubmit() {
      this.addtransference_location = {};
      this.addtransference_locationdialog = true;
    },

    async addtransference_locationSubmit() {
      if (this.$refs.addtransference_locationform.validate()) {
        try {
          this.addtransference_location.ApiKey = this.ApiKey;
          this.addtransference_location.tlid_ref = this.id_ref;
          this.addtransference_location.tlid_card = this.user.id_card;
          this.addtransference_location.tlid_branch = this.user.pt_id_branch;
          const result = await this.$http.post(
            "transference_location.insert.php",
            this.addtransference_location
          );

          if (result.data.status) {
            this.showSuccess("ดำเนินการข้อมูลเรียบร้อย");
            await this.transference_locationQueryAll();
          } else {
            this.showError(
              "บันทึกข้อมูลผิดพลาด รายการลำดับ หรือ ชื่อหน่วยงานแหน่งใหม่ซ้ำ"
            );
          }
        } catch (error) {
          this.showError("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
        }
        this.addtransference_locationdialog = false;
      }
    },

    async transference_locationDelete(id_tfl) {
      try {
        const result = await this.$http.post("transference_location.php", {
          ApiKey: this.ApiKey,
          id_tfl: id_tfl
        });
        this.edittransference_location = result.data;
        this.delettransference_locationdialog = true;
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการโหลดข้อมูล");
      }
    },

    async deletetransference_locationSubmit() {
      try {
        this.edittransference_location.ApiKey = this.ApiKey;
        const result = await this.$http.post(
          "transference_location.delete.php",
          this.edittransference_location
        );

        if (result.data.status) {
          this.showSuccess("ดำเนินการลบข้อมูลเรียบร้อย");
          await this.transference_locationQueryAll();
        } else {
          this.showError("ดำเนินการลบผิดพลาด");
        }
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการลบข้อมูล");
      }
      this.delettransference_locationdialog = false;
    },

    async OnEnterUpdate() {
      try {
        const result = await this.$http.post("personnel_temporary.php", {
          ApiKey: this.ApiKey,
          id_card: this.transference_personnels.switch_position
        });
        this.personnel_temporarys = result.data;
      } catch (error) {
        this.showError("ไม่พบข้อมูลบุคลากร");
      }
    },

    async addtransference_personnelSubmit() {
      const confirmed = await this.confirmAction(
        "ท่านประสงค์ยืนย้าย และดำเนินการในขั้นตอนถัดไป",
        "บันทึกรายการชั่วคราว"
      );

      if (confirmed) {
        try {
          const payload = {
            ApiKey: this.ApiKey,
            id_ref: this.id_ref,
            time_s: this.periods.period_times,
            year_s: this.periods.period_year,
            id_card: this.user.id_card,
            date_time: this.date_today,
            age_time: this.get_gov_Age,
            age_app_time: this.get_Appoint_Age,
            type_move: "nm",
            transfer_status: "temporary",
            college_code_now: this.user.college_code,
            tp_steps: 1
          };

          const result = await this.$http.post(
            "transference_personnel.insert.php",
            payload
          );

          if (result.data.status) {
            this.showSuccess("ดำเนินการข้อมูลเรียบร้อย");
            await this.transference_personnelAll();
          } else {
            this.showError("ดำเนินการผิดพลาด");
          }
        } catch (error) {
          this.showError("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
        }
      }
    },

    async updatetransference_personnelsSubmit(step) {
      try {
        this.transference_personnels.ApiKey = this.ApiKey;
        this.transference_personnels.age_time = this.get_gov_Age;
        this.transference_personnels.age_app_time = this.get_Appoint_Age;
        this.transference_personnels.tp_ageUser = this.get_ageUser;

        this.transference_personnels.tp_steps = step;
        if (this.transference_personnels.reason_1 != "1" && this.transference_personnels.reason_1 != 1) {
        this.transference_personnels.reason_1 = "0";
        this.transference_personnels.reason_1_spouse = "-";
        this.transference_personnels.reason_1_occupation = "-";
        this.transference_personnels.reason_1_location = "-";
        this.transference_personnels.reason_1_domicile = "-";
        this.transference_personnels.reason_1_prefecture = "-";
        this.transference_personnels.reason_1_district = "-";
        this.transference_personnels.reason_1_child = "-";
        this.transference_personnels.reason_1_childage = "-";
        this.transference_personnels.reason_1_childprefecture = "-";
        this.transference_personnels.reason_1_childdictrict = "-";
      }

      if (this.transference_personnels.reason_2 != "1" && this.transference_personnels.reason_2 != 1) {
        this.transference_personnels.reason_2 = "0";
        this.transference_personnels.reason_2_fyear = "-";
        this.transference_personnels.reason_2_myear = "-";
        this.transference_personnels.reason_2_domicile = "-";
        this.transference_personnels.reason_2_prefecture = "-";
        this.transference_personnels.reason_2_district = "-";
      }

      if (this.transference_personnels.reason_3 != "1" && this.transference_personnels.reason_3 != 1) {
        this.transference_personnels.reason_3 = "0";
        this.transference_personnels.reason_3_domicile = "-";
        this.transference_personnels.reason_3_prefecture = "-";
        this.transference_personnels.reason_3_district = "-";
      }

      if (this.transference_personnels.reason_4 != "1" && this.transference_personnels.reason_4 != 1) {
        this.transference_personnels.reason_4 = "0";
        this.transference_personnels.reason_4_detail = "-";
      }

        const result = await this.$http.post(
          "transference_personnel.update.php",
          this.transference_personnels
        );

        if (result.data.status) {
          this.showSuccess("ดำเนินการข้อมูลเรียบร้อย");
          await this.transference_personnelAll();
        } else {
          this.showError("ดำเนินการผิดพลาด");
        }
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
      }
    },

    async confirmsSubmit() {
      this.confirm_dialog = true;
    },

    async updatetransference_personnelsSaveSubmit() {
      try {
        this.transference_personnels.ApiKey = this.ApiKey;
        this.transference_personnels.transfer_status = "save";
        this.transference_personnels.date_time = this.date_today;

        const locationPayload = {
          ApiKey: this.ApiKey,
          tlid_ref: this.id_ref,
          tlstatus_confirm: "save"
        };

        const [result, result_up] = await Promise.all([
          this.$http.post(
            "transference_personnel.update.php",
            this.transference_personnels
          ),
          this.$http.post("transference_location.update.php", locationPayload)
        ]);
        ;
   
        if (result.data.status || result_up.data.status) {
          this.showSuccess("ดำเนินการข้อมูลเรียบร้อย");
          await this.updatetransference_personnelsSubmit(11);
          await this.transference_personnelAll();
        } else {
          this.showError("ดำเนินการผิดพลาด");
        }
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
      }
      this.confirm_dialog = false;
    },

    async confirmAction(title, text) {
      const result = await Swal.fire({
        title: title,
        text: text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b3151b",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      });
      return result.isConfirmed;
    },

    // Geographic data loading methods
    async prefectureQueryAll1(province_ID) {
      const result = await this.$http.post("prefecture.php", { province_ID });
      this.prefectures1 = result.data;
    },

    async prefectureQueryAll2(province_ID) {
      const result = await this.$http.post("prefecture.php", { province_ID });
      this.prefectures2 = result.data;
    },

    async prefectureQueryAll3(province_ID) {
      const result = await this.$http.post("prefecture.php", { province_ID });
      this.prefectures3 = result.data;
    },

    async districtQueryAll1(prefecture_ID) {
      const result = await this.$http.post("districts.php", { prefecture_ID });
      this.district1 = result.data;
    },

    async districtQueryAll2(prefecture_ID) {
      const result = await this.$http.post("districts.php", { prefecture_ID });
      this.district2 = result.data;
    },

    async districtQueryAll3(prefecture_ID) {
      const result = await this.$http.post("districts.php", { prefecture_ID });
      this.district3 = result.data;
    },
    calculateAge(birthDate, currentDate) {
      const totalMonths =
        (currentDate.getFullYear() - birthDate.getFullYear()) * 12 +
        currentDate.getMonth() -
        birthDate.getMonth();

      let years = currentDate.getFullYear() - birthDate.getFullYear();
      if (
        birthDate.getMonth() > currentDate.getMonth() ||
        (birthDate.getMonth() === currentDate.getMonth() &&
          birthDate.getDate() > currentDate.getDate())
      ) {
        years--;
      }

      let days, months;
      if (birthDate.getDate() > currentDate.getDate()) {
        months = totalMonths % 12;
        if (months === 0) months = 11;
        const daysInMonth = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          0
        ).getDate();
        days = daysInMonth - (birthDate.getDate() - currentDate.getDate());
      } else {
        days = currentDate.getDate() - birthDate.getDate();
        months =
          birthDate.getMonth() === currentDate.getMonth()
            ? 0
            : totalMonths % 12;
      }

      return `${years} ปี ${months} เดือน ${days} วัน`;
    }
  },

  computed: {
    date_today_cal() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear();

      today = yyyy + "-" + mm + "-" + dd;
      return today;
    },

    get_Appoint_Age() {
      let today = new Date(this.periods.period_cal_end);
      let DOB = new Date(this.user.date_app_now);

      let totalMonths =
        (today.getFullYear() - DOB.getFullYear()) * 12 +
        today.getMonth() -
        DOB.getMonth();
      totalMonths += today.getDay() < DOB.getDay() ? -1 : 0;
      let years = today.getFullYear() - DOB.getFullYear();
      if (DOB.getMonth() > today.getMonth()) years = years - 1;
      else if (DOB.getMonth() === today.getMonth())
        if (DOB.getDate() > today.getDate()) years = years - 1;

      let days;
      let months;

      if (DOB.getDate() > today.getDate()) {
        months = totalMonths % 12;
        if (months == 0) months = 11;
        let x = today.getMonth();
        switch (x) {
          case 1:
          case 3:
          case 5:
          case 7:
          case 8:
          case 10:
          case 12: {
            let a = DOB.getDate() - today.getDate();
            days = 31 - a;
            break;
          }
          default: {
            let a = DOB.getDate() - today.getDate();
            days = 30 - a;
            break;
          }
        }
      } else {
        days = today.getDate() - DOB.getDate();
        if (DOB.getMonth() === today.getMonth()) months = 0;
        else months = totalMonths % 12;
      }
      let age = years + " ปี " + months + " เดือน " + days + " วัน";
      return age;
    },
    get_ageUser() {
      let today = new Date(this.date_today_cal);
      let DOB = new Date(
        parseInt(this.user.brith_year) -
          543 +
          "-" +
          this.user.brith_month +
          "-" +
          this.user.brith_day
      );
      let totalMonths =
        (today.getFullYear() - DOB.getFullYear()) * 12 +
        today.getMonth() -
        DOB.getMonth();
      totalMonths += today.getDay() < DOB.getDay() ? -1 : 0;
      let years = today.getFullYear() - DOB.getFullYear();
      if (DOB.getMonth() > today.getMonth()) years = years - 1;
      else if (DOB.getMonth() === today.getMonth())
        if (DOB.getDate() > today.getDate()) years = years - 1;

      let days;
      let months;

      if (DOB.getDate() > today.getDate()) {
        months = totalMonths % 12;
        if (months == 0) months = 11;
        let x = today.getMonth();
        switch (x) {
          case 1:
          case 3:
          case 5:
          case 7:
          case 8:
          case 10:
          case 12: {
            let a = DOB.getDate() - today.getDate();
            days = 31 - a;
            break;
          }
          default: {
            let a = DOB.getDate() - today.getDate();
            days = 30 - a;
            break;
          }
        }
      } else {
        days = today.getDate() - DOB.getDate();
        if (DOB.getMonth() === today.getMonth()) months = 0;
        else months = totalMonths % 12;
      }
      let age = years + " ปี";
      return age;
    },
    id_ref() {
      return (
        "gov_" +
        this.periods.period_times +
        this.periods.period_year +
        this.user.id_card
      );
    },

    checkEventAss() {
      return (
        this.transference_locations.length ||
        String(this.transference_personnels.switch_position).length > 10
      );
    },

    marital_status() {
      const statusMap = {
        single: "โสด",
        married: "สมรส",
        widow: "หม้าย",
        divorce: "หย่า",
        separate: "แยกกันอยู่"
      };
      return statusMap[this.user.marital_status] || "";
    },

    date_today() {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear() + 543;
      return `${dd}/${mm}/${yyyy}`;
    },

    date_appoin_ch() {
      const monthNames = [
        "",
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
      ];

      if (
        !this.user.appoin_day ||
        !this.user.appoin_month ||
        !this.user.appoin_year
      ) {
        return "-";
      }

      const day = this.user.appoin_day;
      const month = monthNames[parseInt(this.user.appoin_month)];
      const year = parseInt(this.user.appoin_year);
      return `${day} ${month} ${year}`;
    },

    get_Appoint_Age() {
      if (!this.user.date_app_now || !this.periods.period_cal_end) return "";

      const today = new Date(this.periods.period_cal_end);
      const DOB = new Date(this.user.date_app_now);

      return this.calculateAge(DOB, today);
    },

    get_gov_Age() {
      if (
        !this.user.appoin_year ||
        !this.user.appoin_month ||
        !this.user.appoin_day
      )
        return "";

      const today = new Date();
      const DOB = new Date(
        parseInt(this.user.appoin_year) - 543,
        parseInt(this.user.appoin_month) - 1,
        parseInt(this.user.appoin_day)
      );

      return this.calculateAge(DOB, today);
    },

    get_gov_Age_year() {
      if (!this.user.date_app_now || !this.periods.period_cal_end) return 0;

      const today = new Date(this.periods.period_cal_end);
      const DOB = new Date(this.user.date_app_now);

      let years = today.getFullYear() - DOB.getFullYear();
      if (
        DOB.getMonth() > today.getMonth() ||
        (DOB.getMonth() === today.getMonth() && DOB.getDate() > today.getDate())
      ) {
        years--;
      }
      return years;
    }
  },

  watch: {
    "transference_personnels.reason_1_domicile"() {
      if (this.transference_personnels.reason_1_domicile) {
        this.prefectureQueryAll1(
          this.transference_personnels.reason_1_domicile
        );
      }
    },

    "transference_personnels.reason_1_prefecture"() {
      if (this.transference_personnels.reason_1_prefecture) {
        this.districtQueryAll1(
          this.transference_personnels.reason_1_prefecture
        );
      }
    },

    "transference_personnels.reason_2_domicile"() {
      if (this.transference_personnels.reason_2_domicile) {
        this.prefectureQueryAll2(
          this.transference_personnels.reason_2_domicile
        );
      }
    },

    "transference_personnels.reason_2_prefecture"() {
      if (this.transference_personnels.reason_2_prefecture) {
        this.districtQueryAll2(
          this.transference_personnels.reason_2_prefecture
        );
      }
    },

    "transference_personnels.reason_3_domicile"() {
      if (this.transference_personnels.reason_3_domicile) {
        this.prefectureQueryAll3(
          this.transference_personnels.reason_3_domicile
        );
      }
    },

    "transference_personnels.reason_3_prefecture"() {
      if (this.transference_personnels.reason_3_prefecture) {
        this.districtQueryAll3(
          this.transference_personnels.reason_3_prefecture
        );
      }
    }
  }
};
</script>

<style scoped>
.flex-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
</style>
